module.exports = __webpack_public_path__ + "fontawesome-webfont.e57c3d7fa8378d92fa37.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.woff2?v=4.6.3
// module id = 1377
// module chunks = 7